import React, { useEffect, useState } from 'react'
import { PieChart } from 'react-minimal-pie-chart'
import { Row } from 'antd'

const Aging = (props) => {
  const [dataPie, setDataPie] = useState()
  const { token, data, word } = props

  useEffect(() => {
    if (data.length == 0) {
      setDataPie([{ title: 'empty', value: 1, color: 'rgb(239, 239, 239)' }])
    } else {
      let arr = [
        { title: '30', value: data.age_30, color: '#FFAF00' },
        { title: '60', value: data.age_60, color: '#19D895' },
        { title: '90', value: data.age_90, color: '#00B7A3' },
        { title: '90plus', value: data.age_90plus, color: '#6DB9FF' },
        { title: 'notdue', value: data.age_notdue, color: '#127EC3' },
      ]
      setDataPie(arr)
    }
  }, [data])

  return (
    <div>
      <h3 className='header' style={{ marginTop: '0px' }}>{word['Project_Aging']}</h3>
      <Row className='Body' style={{ marginTop: '-32px' }}>
        <div className='pie'>
          <PieChart
            style={{
              fontFamily: '"Nunito Sans", -apple-system, Helvetica, Arial, sans-serif',
              fontSize: '8px',
            }}
            data={dataPie}
            lineWidth={30}
          ></PieChart>
          <div className='totalProject'>
            <p>{word['Total']}</p>
            <h1>{data?.total == undefined ? 0 : data.total}</h1>
            <p>{word['projects']}</p>
          </div>
        </div>

        <Row className='tworows'>
          <div className='inbox'>
            <div className='point status_30'></div>
            <div className='pertext-content'>
              <Row className='percent-area'>
                <text>
                  1- 30 {word['days']}
                  <text className='p2'>
                    ({data?.percent_age_30 == undefined ? 0 : data?.percent_age_30}%)
                  </text>
                </text>
              </Row>
              <h1>{data?.age_30 == undefined ? 0 : data?.age_30}</h1>
            </div>
          </div>
          <div className='inbox'>
            <div className='point status_90plus'></div>
            <div className='pertext-content'>
              <Row className='percent-area'>
                <text>
                  90+ {word['days']}
                  <text className='p2'>
                    (
                    {data?.percent_age_90plus == undefined ? 0 : data?.percent_age_90plus}
                    %)
                  </text>
                </text>
              </Row>
              <h1>{data?.age_90plus == undefined ? 0 : data?.age_90plus}</h1>
            </div>
          </div>
          <div className='inbox'>
            <div className='point status_60'></div>
            <div className='pertext-content'>
              <Row className='percent-area'>
                <text>
                  31- 60 {word['days']}
                  <text className='p2'>
                    ({data?.percent_age_60 == undefined ? 0 : data?.percent_age_60}%)
                  </text>
                </text>
              </Row>
              <h1>{data?.age_60 == undefined ? 0 : data?.age_60}</h1>
            </div>
          </div>
          <div className='inbox'>
            <div className='point Notdue'></div>
            <div className='pertext-content'>
              <Row className='percent-area'>
                <text>
                  {word['Not_due']}
                  <text className='p2'>
                    (
                    {data?.percent_age_notdue == undefined ? 0 : data?.percent_age_notdue}
                    %)
                  </text>
                </text>
              </Row>
              <h1>{data?.age_notdue == undefined ? 0 : data?.age_notdue}</h1>
            </div>
          </div>
          <div className='inbox'>
            <div className='point status_90'></div>
            <div className='pertext-content'>
              <Row className='percent-area'>
                <text>
                  61- 90 {word['days']}
                  <text className='p2'>
                    ({data?.percent_age_90 == undefined ? 0 : data?.percent_age_90}%)
                  </text>
                </text>
              </Row>
              <h1>{data?.age_90 == undefined ? 0 : data?.age_90}</h1>
            </div>
          </div>
        </Row>
      </Row>
      <p
        style={{
          fontSize: '12px',
          color: '#FF6258',
          marginTop: '31px',
          marginBottom: '-15px',
        }}
      >
        *Remark: The number of project that consist of "Registered" and "Kick off" status
      </p>
    </div>
  )
}
export default Aging
